import { MultigameParams } from "../../MultigameParams";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../../SlotGameInitData";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";

export class LavaLandMysticWarriorsFillingPot_Responsive extends SlotGameType1_Responsive {

        
    protected override helpFactory: IHelpFactory = new LavaLandMysticWarriorsFillingPotHelpFactory();
    //LED COLOR
    protected override ColorLed:string="137,0,0\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData , gameName : string = "LavaLandMysticWarriorsFillingPot") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/montana.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // // }
    // protected override LoadTitle(resourceManager: ResourceManager) {
    //     super.LoadTitle(resourceManager);
    //     // this.TitleContainer.style.backgroundSize = "cover";
    // }
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

}

//Help Colorized
class LavaLandMysticWarriorsFillingPotHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LavaLandMysticWarriorsFillingPotHelp(params);
    }
}

class LavaLandMysticWarriorsFillingPotHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

// }